import { AddressDetailsDto } from '../interfaces/loggedInUserDto';

export class PhysicianOrder {
  physicianId: string;
  firstName: string;
  lastName: string;
  title: string;
  npiNumber?: number;
  addressesDto: AddressDetailsDto;
}

export class ReferringPhysician {
  physicianId: string;
  firstName: string;
  lastName: string;
  title: string;
  npiNumber: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  zipCode: string;
  stateCode: string;
  stateName: string;
  country: string;
  phone: string;
  faxNumbers: string;
  emails: string;
}

export class ReferringRequest {
  bu: string[];
  physicianSearchCriteria: string[];
}

export class ReferringAddressesDto {
  addressLine1: string;
  addressLine2?: any;
  city: string;
  zipCode: string;
  stateCode: string;
  stateName?: any;
  country: string;
  phone: string;
  faxNumbers?: any;
  emails: string;
  checked?: boolean;
}

export class ReferencePhysicianDto {
  physicianId: string;
  firstName: string;
  lastName: string;
  title?: any;
  npiNumber: number;
  addressesDto: ReferringAddressesDto[];
}
